export default "__VITE_ASSET__CD9a9A6P__"